"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/common/v1/health.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthResponse = exports.HealthRequest = exports.healthStatusToJSON = exports.healthStatusFromJSON = exports.HealthStatus = void 0;
/* eslint-disable */
exports.HealthStatus = {
    HEALTH_STATUS_UNSPECIFIED: "HEALTH_STATUS_UNSPECIFIED",
    /** HEALTH_STATUS_SERVING - The application run normally and successfully */
    HEALTH_STATUS_SERVING: "HEALTH_STATUS_SERVING",
    /** HEALTH_STATUS_WARNING - An error is occurred recently and can produce more errors. One or more components in the stack might become overloaded soon. */
    HEALTH_STATUS_WARNING: "HEALTH_STATUS_WARNING",
    /** HEALTH_STATUS_DEGRADED - A partial anomaly of full outage of service. Non-security patches might be available. */
    HEALTH_STATUS_DEGRADED: "HEALTH_STATUS_DEGRADED",
    /** HEALTH_STATUS_CRITICAL - One or more components in the stack might be in an unusable status and the stack might become unresponsive soon. Security patches might be available. */
    HEALTH_STATUS_CRITICAL: "HEALTH_STATUS_CRITICAL",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function healthStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "HEALTH_STATUS_UNSPECIFIED":
            return exports.HealthStatus.HEALTH_STATUS_UNSPECIFIED;
        case 1:
        case "HEALTH_STATUS_SERVING":
            return exports.HealthStatus.HEALTH_STATUS_SERVING;
        case 2:
        case "HEALTH_STATUS_WARNING":
            return exports.HealthStatus.HEALTH_STATUS_WARNING;
        case 3:
        case "HEALTH_STATUS_DEGRADED":
            return exports.HealthStatus.HEALTH_STATUS_DEGRADED;
        case 4:
        case "HEALTH_STATUS_CRITICAL":
            return exports.HealthStatus.HEALTH_STATUS_CRITICAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.HealthStatus.UNRECOGNIZED;
    }
}
exports.healthStatusFromJSON = healthStatusFromJSON;
function healthStatusToJSON(object) {
    switch (object) {
        case exports.HealthStatus.HEALTH_STATUS_UNSPECIFIED:
            return "HEALTH_STATUS_UNSPECIFIED";
        case exports.HealthStatus.HEALTH_STATUS_SERVING:
            return "HEALTH_STATUS_SERVING";
        case exports.HealthStatus.HEALTH_STATUS_WARNING:
            return "HEALTH_STATUS_WARNING";
        case exports.HealthStatus.HEALTH_STATUS_DEGRADED:
            return "HEALTH_STATUS_DEGRADED";
        case exports.HealthStatus.HEALTH_STATUS_CRITICAL:
            return "HEALTH_STATUS_CRITICAL";
        case exports.HealthStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.healthStatusToJSON = healthStatusToJSON;
function createBaseHealthRequest() {
    return {};
}
exports.HealthRequest = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.HealthRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseHealthRequest();
        return message;
    },
};
function createBaseHealthResponse() {
    return { status: exports.HealthStatus.HEALTH_STATUS_UNSPECIFIED };
}
exports.HealthResponse = {
    fromJSON: function (object) {
        return {
            status: isSet(object.status) ? healthStatusFromJSON(object.status) : exports.HealthStatus.HEALTH_STATUS_UNSPECIFIED,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.status !== exports.HealthStatus.HEALTH_STATUS_UNSPECIFIED) {
            obj.status = healthStatusToJSON(message.status);
        }
        return obj;
    },
    create: function (base) {
        return exports.HealthResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseHealthResponse();
        message.status = (_a = object.status) !== null && _a !== void 0 ? _a : exports.HealthStatus.HEALTH_STATUS_UNSPECIFIED;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=health.js.map